import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderList as _renderList, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { style: {"white-space":"nowrap"} }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" (")
const _hoisted_3 = /*#__PURE__*/_createVNode("label", { style: {"color":"#8a8a8a"} }, "非厦门号码请在前面加0，比如 013899998888", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(") ")
const _hoisted_5 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_cus_option = _resolveComponent("cus-option")
  const _component_cus_select = _resolveComponent("cus-select")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_button = _resolveComponent("el-button")
  const _component_dialog_shell = _resolveComponent("dialog-shell")

  return (_openBlock(), _createBlock(_component_dialog_shell, {
    title: _ctx.title[_ctx.identity],
    footerType: "customize",
    onClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('close'))),
    onSubmit: _ctx.submit
  }, {
    footer: _withCtx(() => [
      _createVNode("span", _hoisted_5, [
        (_ctx.isShowResetBtn)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              onClick: _ctx.ResetPw,
              disabled: _ctx.isDisabledResetBtn
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$wordList.TabelResetPwTitle), 1)
              ]),
              _: 1
            }, 8, ["onClick", "disabled"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_button, {
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('close')))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$wordList.TabelFootCancel), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.submit
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$wordList.TabelFootSubmit), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref: "formRef",
        "label-position": _ctx.$formLabelPosition,
        model: _ctx.formData,
        rules: _ctx.rules
      }, {
        default: _withCtx(() => [
          (_ctx.identity === 'single')
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                label: _ctx.$wordList.TabelPersonUserInHtmlName,
                prop: "Name"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formData.Name,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.Name = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.identity === 'community')
            ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                _createVNode(_component_el_form_item, {
                  label: _ctx.$wordList.TabelPropertyManageFirstName,
                  prop: "FirstName"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.formData.FirstName,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.FirstName = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_form_item, {
                  label: _ctx.$wordList.TabelPropertyManageLastName,
                  prop: "LastName"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.formData.LastName,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formData.LastName = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ], 64))
            : _createCommentVNode("", true),
          (!_ctx.isCNServer)
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 2,
                label: _ctx.$wordList.TabelPropertyManageEmail,
                prop: "Email"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formData.Email,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formData.Email = $event)),
                    "auto-complete": "off"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form_item, {
            label: _ctx.$wordList.ProperAllTextCountryRegion
          }, {
            default: _withCtx(() => [
              _createVNode(_component_cus_select, {
                modelValue: _ctx.formData.PhoneCode,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.formData.PhoneCode = $event)),
                filter: "",
                disabled: _ctx.isCNServer ? true : false
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getPhoneCodeOps(), (item) => {
                    return (_openBlock(), _createBlock(_component_cus_option, {
                      key: item,
                      value: item.value,
                      label: item.label
                    }, null, 8, ["value", "label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$wordList.ProperAllTextMobileNumber,
            prop: "MobileNumber"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.MobileNumber,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.formData.MobileNumber = $event)),
                onInput: _ctx.limitMobileNumberType
              }, null, 8, ["modelValue", "onInput"])
            ]),
            _: 1
          }, 8, ["label"]),
          (_ctx.showLandLine)
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 3,
                label: _ctx.$wordList.ProperAllTextLandline
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formData.Phone,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.formData.Phone = $event))
                  }, null, 8, ["modelValue"]),
                  _createVNode("label", _hoisted_1, [
                    (_ctx.isCNServer)
                      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                          _hoisted_2,
                          _hoisted_3,
                          _hoisted_4
                        ], 64))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.isNew)
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 4,
                label: _ctx.$wordList.AccessFloor,
                prop: "AccessFloor"
              }, {
                default: _withCtx(() => [
                  _createVNode("div", null, [
                    _createVNode(_component_el_select, {
                      multiple: "",
                      size: "small",
                      style: {"width":"100%"},
                      "multiple-limit": _ctx.multipleLimitAccFloor,
                      onChange: _ctx.multipleAccFloorChange,
                      placeholder: _ctx.details.Floor||'',
                      "model-value": _ctx.formData.AccessFloor,
                      "onUpdate:modelValue": _ctx.updateAccessFloor,
                      onRemoveTag: _ctx.removeTag,
                      "fit-input-width": true
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.accessibleFloorOptions, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.value,
                            label: item.label,
                            value: item.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["multiple-limit", "onChange", "placeholder", "model-value", "onUpdate:modelValue", "onRemoveTag"])
                  ])
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["label-position", "model", "rules"])
    ]),
    _: 1
  }, 8, ["title", "onSubmit"]))
}